import { Menu, HelpCircle } from 'lucide-react';
import React from 'react';
import { useAppFeatures } from '../../app/AppRootProviders';
import { Button } from '../../components/button';
import RecentActivitiesDropdown from './NotificationDropdown';
import AdminProfileDropdown from './components/AdminProfileDropdown';
import MerchantProfileDropdown from './components/MerchantProfileDropdown';

interface TopbarProps {
    sidebarOpen: boolean;
    setSidebarOpen: (open: boolean) => void;
    onLogout: () => void;
    user?: { email?: string, profile_image_url?: string, first_name?: string, last_name?: string, role?: string };
}

const Topbar: React.FC<TopbarProps> = ({
    sidebarOpen,
    setSidebarOpen,
    onLogout,
    user
}) => {
    const { isFeatureEnabled } = useAppFeatures();
    const isMerchantUser = user?.role === 'merchant';
    const showRecentActivities = isFeatureEnabled('recent_activities');

    return (
        <header className="sticky top-0 z-40 flex items-center h-16 min-h-16 px-8 bg-white border-b border-r-0 justify-end dark:bg-gray-900 dark:border-gray-800">
            <div className="flex items-center gap-2 lg:hidden absolute left-8">
                <Button variant="ghost" size="icon" onClick={() => setSidebarOpen(true)}>
                    <Menu className="h-5 w-5" />
                </Button>
            </div>
            <div className="flex items-center gap-4">
                {/* Recent Activities dropdown */}
                {showRecentActivities && (
                    <RecentActivitiesDropdown />
                )}

                {/* Help Center */}
                <Button 
                    variant="ghost" 
                    size="icon" 
                    onClick={() => window.open('https://civicpoints.zendesk.com/hc/en-us', '_blank')} 
                    aria-label="Help Center"
                >
                    <HelpCircle className="h-5 w-5" />
                </Button>

                {isMerchantUser ? (
                    <MerchantProfileDropdown user={user} onLogout={onLogout} />
                ) : (
                    <AdminProfileDropdown user={user} onLogout={onLogout} />
                )}
                <span className="font-medium dark:text-gray-100">{(user?.first_name && user?.last_name) ? `${user.first_name} ${user.last_name}` : 'Admin'}</span>
            </div>
        </header>
    );
};

export default Topbar;
